import { render, staticRenderFns } from "./StageContainer.vue?vue&type=template&id=633e000a&scoped=true&"
import script from "./StageContainer.vue?vue&type=script&lang=ts&"
export * from "./StageContainer.vue?vue&type=script&lang=ts&"
import style0 from "./StageContainer.vue?vue&type=style&index=0&id=633e000a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e000a",
  null
  
)

export default component.exports